import $ from 'jquery';
import Steps from 'portlets/site/connect/steps/steps';
import Sim from 'portlets/site/connect/sim/sim';
import Transfer from 'portlets/site/connect/transfer/transfer';
import Info from 'portlets/site/connect/info/info';
import Documents from 'portlets/site/connect/documents/documents';
import Thank from 'portlets/site/connect/thank/thank';
import TariffType from 'portlets/site/connect/tariff-type/tariff-type';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaConnect',
			dom: {
				steps: '#yotaConnectSteps',
				transfer: '#yotaConnectTransfer',
				sim: '#yotaConnectSim',
				info: '#yotaConnectInfo',
				docs: '#yotaConnectDocuments',
				thank: '#yotaConnectThank',
				tariffType: '#yotaTariffType',
				next: '.js-connect-next',
				tostep: '.js-connect-tostep',
				finish: '.js-connect-finish'
			},
			classes: {
				load: 'b-connect_state_load'
			},
			TARIFF_TYPE_SNG: 'TARIFF_TYPE_SNG',
			TARIFF_TYPE_B2B: 'TARIFF_TYPE_B2B'
		};

		this.options = $.extend(true, {}, defaults, options);
		this.data = false;
		this.sended = false;
		this.$el = $(this.options.el);
		this.$window = $(window);
		return this;
	}

	getDom() {
		this.$steps = this.$el.find(this.options.dom.steps);
		this.$sim = this.$el.find(this.options.dom.sim);
		this.$transfer = this.$el.find(this.options.dom.transfer);
		this.$info = this.$el.find(this.options.dom.info);
		this.$docs = this.$el.find(this.options.dom.docs);
		this.$thank = this.$el.find(this.options.dom.thank);
		this.$tariffType = this.$el.find(this.options.dom.tariffType);

		this.$next = this.$el.find(this.options.dom.next);
		this.$tostep = this.$el.find(this.options.dom.tostep);
		this.$finish = this.$el.find(this.options.dom.finish);
		return this;
	}

	finish() {
		this.steps.update({
			sim: {
				active: true,
				complete: true
			},
			info: {
				active: true,
				complete: true
			},
			docs: {
				active: true,
				complete: true
			}
		});
	}

	send(backstep, event) {
		const $target = $(event.currentTarget);
		const step = $target.data('step');
		const self = this;

		if (step === 'info' && backstep === false) {
			self.openTariffType();
			// $.ajax({
			// 	url: self.$el.data('check-sng'),
			// 	type: self.$el.data('method'),
			// 	data: $.param({inn: this.info.data.inn}),
			// 	dataType: 'json',
			// 	success: function (json) {
			// 		if (json && json.available) {
			// 			self.openTariffType();
			// 		} else {
			// 			self.checkData(step, backstep);
			// 		}
			// 	}
			// });
		} else {
			this.checkData(step, backstep);
		}

		return self;
	}

	checkData(step, backstep) {
		const data = {};
		data.step = step;
		data.backstep = backstep;

		if (this.sim) {
			data.sim = this.sim.get();
		}
		if (this.transfer) {
			data.transfer = this.transfer.get();
		}
		if (this.info) {
			data.info = this.info.get();
		}

		const self = this;

		if (!self.sended && data.transfer !== false) {
			self.$el.addClass(self.options.classes.load);
			self.sended = true;
			$.ajax({
				url: self.$el.data('action'),
				type: self.$el.data('method'),
				data: $.param(data),
				dataType: 'json',
				success: function (json) {
					self.sended = false;
					if (json) {
						if (self.docs) {
							self.docs.update(json.docs);
						}
						if (self.steps) {
							self.steps.update(json.steps);
						}
						if (self.sim) {
							self.sim.update(json.sim);
						}
						if (self.info) {
							self.info.update(json.info);
						}
						if (self.thank) {
							self.thank.update(json.thank);
						}
					}
					self.$el.removeClass(self.options.classes.load);
					if (json && self.transfer) {
						self.transfer.update(json.transfer);
					}
				}
			});
		}

	}

	openTariffType() {
		this.tariffType.open({
			quantity: this.sim.data.quantity,
			mnp: this.sim.data.mnp,
			fields: this.transfer.fields
		});
		return this;
	}

	render() {
		if (this.$el.length) {
			if (yotaPortlets.connect) {
				this.data = yotaPortlets.connect;
				this.getDom();

				if (this.$steps.length) {
					this.steps = new Steps({
						el: this.$steps,
						data: this.data.steps
					}).render();
				}

				if (this.$sim.length) {
					this.sim = new Sim({
						el: this.$sim,
						data: this.data.sim
					}).render();
				}

				if (this.$transfer.length) {
					this.transfer = new Transfer({
						el: this.$transfer,
						data: this.data.transfer,
						quantity: this.sim.data.quantity
					}).render();
				}

				if (this.$info.length) {
					this.info = new Info({
						el: this.$info,
						data: this.data.info,
						types: this.data.types,
						masks: this.data.masks,
						cities: this.data.cities
					}).render();
				}

				if (this.$docs.length) {
					this.docs = new Documents({
						el: this.$docs,
						data: this.data.docs
					}).render();
				}

				if (this.$thank.length) {
					this.thank = new Thank({
						el: this.$thank,
						data: this.data.thank
					}).render();
				}

				if (this.$tariffType.length) {
					this.tariffType = new TariffType({
						TARIFF_TYPE_SNG: this.options.TARIFF_TYPE_SNG,
						TARIFF_TYPE_B2B: this.options.TARIFF_TYPE_B2B}
					).render();
				}

				this.$next.on('click', this.send.bind(this, false));
				this.$tostep.on('click', this.send.bind(this, true));
				this.$finish.on('click', this.finish.bind(this));

			} else {
				console.error('The connect portlet has no data, set data to "yotaPortlets.connect"');
			}

			this.$window.on('yota.connect.tariffType.submit', (event, tariffType) => {
				this.info.setPackageType(tariffType);

				if (tariffType === this.options.TARIFF_TYPE_SNG) {
					this.sim.setQuantity(1);
				}

				this.checkData('info', false);
			});
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/connect/connect.js